import Store from 'Services/Store';

window.RentPrefs = {
	
	rentWarehouseForm: function(rentwhid){
		
		var title = Loc.g('Modifier un lieu de location');
		if (rentwhid == undefined){
			title = Loc.g('Ajouter un lieu de location');
		}
		
		var options = {
			title	: title,
			width: 600,
			buttons	: [
                {
                    text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
                },
                {
                    text : Loc.g('Enregistrer'),  click : function(){
						$("#rentWarehouseForm").submit();
						}
                }
				],
			callback	: function(){RentPrefs.preparerentWarehouseForm();}
		};

		MyWindow.load("rent_prefs", {action:"rentWarehouseForm", rentwhid:rentwhid} , options);
		
	},
			
	preparerentWarehouseForm :function(){
		
		var formId = "rentWarehouseForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "rentWarehouseForm");
			if (formIsOk){
				Utils.reload();
			}
			
		}, dataType:"json"};
		var data = {action: 'recordPrefsrentwarehouseform'};
		MyForm.prepare(formId, "rent_prefs&"+$.param(data), options, true);
		MyFacture.initEvent();
		
	},
			
	deleteWarehouse: function(rentwhid){

		var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Supprimer"),
					'class' : 'btn btn-primary',
					click : function(){
						var datas = {action:"deleterentwarehouse", rentwhid:rentwhid};
						MyFacture.post("rent_prefs", datas, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer le lieu de location ?"), options);

	},
	
};

window.availablegoodsListing = {
	
	prepareFilterForm: function(listingName){
		
		const action = 'rent_availablegoodslist';
		var options = {success:function(data){
				
			var medataName = "data."+listingName+"_metadatas";
			var meta = eval(medataName);
			Listing.refresh(listingName+"Listing", data, meta);	
				
		}, dataType:"json"};
	
        MyForm.prepare(listingName+"FilterForm", action+"&action=updateListing", options);
	}
};

window.booksListing = {
	
	initCalendarListing: function(){
		
		var cal = $('#booksCalendar');
		
		var relatedtype		= cal.attr('relatedtype');
		var relatedid		= cal.attr('relatedid');
		var aspectratio		= cal.attr('ratio');
		var defaultView		= cal.attr('defaultView');
		var headerLeft		= cal.attr('headerLeft');
		var headerCenter	= cal.attr('headerCenter');
		var headerRight		= cal.attr('headerRight');
		var selectable		= cal.attr('selectable');
		
		var defaultDate		= moment(cal.attr('defaultDate'), Loc.getTimeFormat());
		
		if (!defaultDate.isValid()){
			defaultDate = moment();
		}
		
		var uiLang			= Loc.uilang;
		var hoursFormat		= Store.get('corp').hourformat;
		var timezone		= Store.get('user').timezone;
		var timeformat = hoursFormat === "12" ? 'hh:mm a' : 'HH:mm';
		
		relatedtype		= relatedtype === undefined ? 0 : relatedtype;
		relatedid		= relatedid === undefined ? 0 : relatedid;
		aspectratio		= aspectratio === undefined ? 1.35 : parseFloat(aspectratio);
		defaultView		= (defaultView === undefined || defaultView === "") ? 'month' : defaultView;

		headerLeft	 = headerLeft === undefined ? 'title, prev, next' : headerLeft;
		headerCenter = headerCenter === undefined ? 'month, agendaWeek, agendaDay' : headerCenter;
		headerRight  = headerRight === undefined ? 'today' : headerRight;

		selectable		= selectable === undefined ? true : (selectable === 'Y');
                
		cal.fullCalendar({

			/* General display */
                        
			header: {
				left: headerLeft,
				center: headerCenter,
				right: headerRight
			},
			aspectRatio: aspectratio,
			handleWindowResize: false,
                        
			lang: uiLang,
			firstDay: uiLang === 'fr' ? 1 : 0,
			defaultDate: defaultDate,
			timezone: timezone,
			slotEventOverlap: false,
			
			defaultView: defaultView,
			
			allDayText: Loc.g('Toute la journée'),
			timeFormat: timeformat,
			slotLabelFormat : timeformat,
			weekNumbers: true,
			weekNumberTitle: (uiLang === 'fr') ? 'S' : 'W',
			weekNumberCalculation: 'ISO',
			slotDuration: '00:15:00',
			displayEventEnd: true,
			nextDayThreshold: "00:00:00",
                        
			buttonText: {
				today: Loc.g("Aujourd'hui"),
			},
			monthNames: [Loc.g('Janvier'), Loc.g('Février'), Loc.g('Mars'), Loc.g('Avril'), Loc.g('Mai'), Loc.g('Juin'), Loc.g('Juillet'), Loc.g('Août'), Loc.g('Septembre'), Loc.g('Octobre'), Loc.g('Novembre'), Loc.g('Décembre')],
			monthNamesShort: [Loc.g('Jan'), Loc.g('Fev'), Loc.g('Mar'), Loc.g('Avr'), Loc.g('Mai'), Loc.g('Jui'), Loc.g('Juil'), Loc.g('Au'), Loc.g('Sep'), Loc.g('Oct'), Loc.g('Nov'), Loc.g('Dec')],
			dayNames: [Loc.g('Dimanche'), Loc.g('Lundi'), Loc.g('Mardi'), Loc.g('Mercredi'), Loc.g('Jeudi'), Loc.g('Vendredi'), Loc.g('Samedi')],
			dayNamesShort: [Loc.g('Dim'), Loc.g('Lun'), Loc.g('Mar'), Loc.g('Mer'), Loc.g('Jeu'), Loc.g('Ven'), Loc.g('Sam')],
                        
			views: {
				week: { // name of view
						titleFormat : 'DD MMMM YYYY',
						columnFormat : 'dddd DD/MM',
						buttonText : Loc.g('Semaine'),
				},
				day: { // name of view
						titleFormat: 'dddd DD MMMM YYYY',
						columnFormat : 'dddd',
						buttonText : Loc.g('Jour'),
				},
				month: { // name of view
						columnFormat : 'dddd',
						buttonText : Loc.g('Mois'),
				},
				listYear: {
					buttonText : Loc.g('Liste / Année'),
				},
				listMonth: {
					buttonText : Loc.g('Liste / Mois'),
				},
				listWeek: {
					buttonText : Loc.g('Liste / Semaine'),
				},
				listDay: {
					buttonText : Loc.g('Liste / Jour'),
				}
			},

			listDayFormat: 'dddd DD MMMM YYYY',
			listDayAltFormat : false,
			noEventsMessage : Loc.g('Il n\'y a aucun évènement à afficher'),
			
			eventMouseover: function(event, jsEvent, view){
				$(this).addClass('eventMouseOver');
			},
					
			eventMouseout: function(event, jsEvent, view){
				$(this).removeClass('eventMouseOver');
			},
			
			eventRender : function( book, element, view ) {


				var content = "<div class='bookCalendar hasTooltip' id='event_"+book.bookData.id+"'>";
				
				content += "<div class='bookCalendarThird'>"
					   + window.i18n.__('Pour %(name)s', {'name' : '<b>' + book.bookData.thirdName + '</b>'})
					 + '</div>';
				var tqBookCalProd = '';
				$.each(book.items, function(index,name){
					if (book.wharehouses[index] == 'NULL') {
						tqBookCalProd += '<p>'+name+" ("+Loc.g('Sans lieu de location')+")</p>";	
					}else{
						tqBookCalProd += '<p>'+name + " (" + book.wharehouses[index] + ")</p>";
					}
				});					
				content += "<div class='bookCalendarProduct bookCalendarProd"+book.bookData.id+"'>"
					    + window.i18n.n__(
						    '%(nb)d produit',
						    '%(nb)d produits',
						    book.items.length,
						    {'nb' : book.items.length}
					      )
					+ "</div>";

				content += "<div class='bookCalendarDate'>";
				content +=	"<div><span class='startDate'>" + " <b>" +  book.bookData.formatted_startTimestamp+ "</b></span> - <span class='endDate'>  <b>" +  book.bookData.formatted_endTimestamp+ "</b></span></div>";
				content += "</div>";

				if (book.bookData.nbEntries > 0){
					var clClass = book.bookData.nbEntries > book.bookData.nbEntriesDone ? "spanLabel-red" : "spanLabel-green";
					content +=	"<div class='bookCalendarCheckList'>" + Loc.g('CheckList') + " <span class='spanLabel "+clClass+"'>" +  book.bookData.nbEntriesDone + " / " + book.bookData.nbEntries + "</span></div>";  
				}
				
				if (book.bookData.nbLinkedDocs > 0){
					var clClass = book.bookData.nbLinkedDocs > 0 ? "spanLabel-green" : "spanLabel-red";
					content +=	"<div class='bookCalendarDocs'>" + Loc.g('Docs générés') + " <span class='spanLabel "+clClass+"'>" +  book.bookData.nbLinkedDocs + "</span></div>";  
				}

				content += "</div>";
				content += "<div class='hidden'>"+tqBookCalProd+"</div>";

				element.addClass(book.bookData.type+"Color").addClass('cancelledColor'+book.bookData.cancelled);
				element.find('.fc-content').replaceWith(content);
				
				return;
				
				}, 
			
				eventAfterAllRender: function(view){
					$('.hasTooltip').each(function() { // Notice the .each() loop, discussed below
						
						$(this).qtip({
							style : {
								classes : 'custom-qtip',
								def		: false
							},
							position: {
								viewport: true,
								target	: $(this).parent()
							},
							content: {
								text : $(this).next('div')
							}
						});
					});
				},

			editable: true,
			selectable: selectable,
			selectHelper: false,

			select: function(start, end, jsEvent, view) {
				
				var startTimestamp = start.format(Loc.getTimeHourFormat());
				
				if (view.name === 'month'){
					end.subtract(1, 'day');
				}
				
				var endTimestamp = end.format(Loc.getTimeHourFormat());
				rentBook.editForm('', startTimestamp, endTimestamp);
				
			},		
					
			eventClick: function(event, jsEvent, view) {
				rentOverview.load(event.bookData.id);
			},
					
			eventDrop: function( event, delta, revertFunc, jsEvent, ui, view ) { 
				
				var startTimestamp	= event.start.format(Loc.getTimeHourFormat());
				var endTimestamp	= event.end.format(Loc.getTimeHourFormat());
				
				var id	= event.bookData.id; 
				
				MyFacture.post("rent_book", {action:"editDateFromCalendar", id:id, startTimestamp:startTimestamp, endTimestamp:endTimestamp}, function(data){
					if (data.updateStatus == "failed"){
						revertFunc();
						MyWindow.alert(Loc.g('Impossible de déplacer cette entrée. Les produits ne sont pas disponibles sur cette période.'), {"type":"warning"});
					} else {
						$('#event_'+id).find('.startDate b').html(startTimestamp);
						$('#event_'+id).find('.endDate b').html(endTimestamp);
					}
				}, "json");
				
				return false;
				
			},	
					
			eventResize: function( event, delta, revertFunc, jsEvent, ui, view ) {
			
				var startTimestamp	= event.start.format(Loc.getTimeHourFormat());
				var endTimestamp	= event.end.format(Loc.getTimeHourFormat());
				
				var id	= event.bookData.id; 
				
				MyFacture.post("rent_book", {action:"editDateFromCalendar", id:id, startTimestamp:startTimestamp, endTimestamp:endTimestamp}, function(data){
					if (data.updateStatus == "failed"){
						revertFunc();
						MyWindow.alert(Loc.g('Impossible de déplacer cette entrée. Le produit n’est pas disponible durant cette période.'), {"type":"warning"});
					} else {
						$('#event_'+id).find('.startDate b').html(startTimestamp);
						$('#event_'+id).find('.endDate b').html(endTimestamp);
					}
				}, "json");
				
				return false;
			
			},
			
			viewRender: function(view, element){
				
				var viewSettings = {};

				var defaultCalendarDate = $('#booksCalendar').fullCalendar('getView').calendar.optionsModel._props.defaultDate.format(Loc.getTimeFormat());
				var defaultView			= $('#booksCalendar').fullCalendar('getView').calendar.optionsModel._props.defaultView;
				
				if (view.name == "month"){
					var viewStart = view.intervalStart.format(Loc.getTimeFormat());
					var viewEnd   = view.intervalEnd.format(Loc.getTimeFormat());
				} else {
					var viewStart = view.start.format(Loc.getTimeFormat());
					var viewEnd   = view.end.format(Loc.getTimeFormat());
				}
				
				if (defaultCalendarDate != viewStart || defaultView != view.name){
					$('#booksListing_filter_period_rent').val("custom");
					$('#booksListing_period_rent_custom').show();
					$('#booksListing_filter_period_rent_startDate').val(viewStart);
					$('#booksListing_filter_period_rent_endDate').val(viewEnd);
					$('#booksListing_calendarSettings_agendaView').val(view.name);
					$('#booksListing_calendarSettings_startView').val(viewStart);
					Listing.update('booksListing', true);
				}
		
			},
					
			events: function(start, end, timezone, callback) {
		 
				var listing = JSON.parse($('#booksCalendarData').val());

				var books = [];

				$.each( listing, function( bookIndex, bookData) {


					var tmpBook = {
						bookData : bookData,
						title : bookData.itemName,
						wharehouses: bookData.warehouseNames.split(',;:='),
						items: bookData.itemName == null ? '' : bookData.itemName.split(',;:='),
						start: moment(bookData.formatted_startTimestamp, Loc.getTimeHourFormat()),
						end : moment(bookData.formatted_endTimestamp, Loc.getTimeHourFormat()),
						editable: true,
					};
					
					books.push(tmpBook);
				});

				cal.find('.fc-button').addClass('btn btn-primary btn-small').removeClass('fc-state-default');

				callback(books);
				
			}
			
		});
		
	},
        
	changeView : function (view, selectView) {
		if(view == "list"){
			$('#booksCalendar .fc-agendaDay-button').hide();
			$('#booksCalendar .fc-agendaWeek-button').hide();
			$('#booksCalendar .fc-month-button').hide();
			$('#booksCalendar .fc-listYear-button').show();
			$('#booksCalendar .fc-listMonth-button').show();
			$('#booksCalendar .fc-listWeek-button').show();
			$('#booksCalendar .fc-listDay-button').show();
			if(selectView){
				$('#booksCalendar .fc-listMonth-button').click();
			}
		} else if(view == "calendar") {
			$('#booksCalendar .fc-listYear-button').hide();
			$('#booksCalendar .fc-listMonth-button').hide();
			$('#booksCalendar .fc-listWeek-button').hide();
			$('#booksCalendar .fc-listDay-button').hide();
			$('#booksCalendar .fc-agendaDay-button').show();
			$('#booksCalendar .fc-agendaWeek-button').show();
			$('#booksCalendar .fc-month-button').show();
			if(selectView){
				$('#booksCalendar .fc-month-button').click();
			}
		}
	},
	
	prepareFilterForm: function(listingName){
		
		const action = "rent_booklist";
		var options = {success:function(data){
				
			var medataName = "data."+listingName+"_metadatas";
			var meta = eval(medataName);
			Listing.refresh(listingName+"Listing", data, meta);	
			
			var selector = $('#'+listingName+"Listing");
			
			if (meta.displayMode == 'calendar'){
				booksListing.initCalendarListing();
				selector.find('.listingPagination').hide();
				selector.find('.pagination').hide();
				selector.find('.nbPerPage').hide();
				selector.find('.displayColumns').hide();
			} else {
				selector.find('.listingPagination').show();
				selector.find('.pagination').show();
				selector.find('.nbPerPage').show();
				selector.find('.displayColumns').show();
			}
				
		}, dataType:"json"};
	
        MyForm.prepare(listingName+"FilterForm", action+"&action=updateListing", options);
		
		booksListing.initCalendarListing();
		
	}
			
};

window.rentOverview = {
	
	load: function(id){
		
		var title = Loc.g('Apercu de la location');

        var closeButton = {
            text : Loc.g("Fermer"), 'class' : 'btn btn-default', click : function(){
                $(this).dialog("close");

                if ($('#booksListing').length > 0){
                    Listing.update('booksListing');
                }

                if ($('#itembooksListing_container').length > 0){
                    Listing.update('itembooksListing');
                }

                if ($('#thirdbooksListing_container').length > 0){
                    Listing.update('thirdbooksListing');
                }
            }
        };

		var convertToRentButton = {
			text : Loc.g("Convertir en location"), 'class' : 'btn btn-primary' ,click : function(){
				$(this).dialog("close");
				rentBook.converToLoc(id);
			}
		}
		
		var createDocumentButton = {
			text : Loc.g("Créer un document"), 'class' : 'btn btn-primary' ,click : function(){
				var thirdid = $('#rentbookOverview #rentBookOverview_thirdid').val();
				var bookid = $('#rentbookOverview #rentBookId').val();

				$(this).dialog("close");

				Third.newDoc(thirdid, 'client', 'rentbook', bookid, 'rent');
			}
		};
		
		var editButton = {
			text : Loc.g("Modifier"),'class' : 'btn btn-primary',click : function(){
				$(this).dialog("close");
				rentBook.editForm(id);
			}
		};




        var disclamerCreateDocumetButton = {
            text : Loc.g("Créer un document") ,'class' : 'btn btn-primary',click : function(){

                var disclamerOptions = {
                    title	:  Loc.g('Créer un document'),
                    type	: "warning",
                    width	: 700,
                    buttons : [closeButton, createDocumentButton],
                    callback: function(){
                        Qtip.init();
                    }
                };

                MyWindow.load("rent_book", {action:"bookCreateDocumentDisclamer", bookid: id}, disclamerOptions);

            }
        }

		var options = {
			title	: title,
			width: 1280,
			
			callback	: function(){
				
				var buttons = [];
                buttons.push(closeButton);

				$.each($('.popupBtns .popupBtn'), function(){
					buttons.push(eval($(this).html()));
				});

				MyWindow.addOption('buttons',buttons,'rentPoupWindow');
				
				MyTabs.initHorizontal("rentHorizontalTab",{
					callback: function (item) {
						// save tabs
						MyFacture.post('staff', {action: 'saveTab', linkedtype: 'rent', 'linkedid': id, openedTab: item.attr('id')});
					}
				});
				
				BriefCaseV2Light.init();
				Annotation.init("rentBookComments");
				checkListDisplayer.init();
				Qtip.init();

				if ($('#stockListingTable').length == 1){
					
					Listing.init("stockmovesListing");
					
					var options = {
						data : {action : 'bookOverviewUpdateStockListing', rentbookid : $('#rentBookId').val()},
						success: function (data) {
							Listing.refresh(data.listingName, data, data[data.metadatasName]);
						},
						dataType: "json"
					};
					MyForm.prepare("stockmovesFilterForm", "rent_book", options);
					
				}
				
				$('#rentbookOverview').on('click','.unLinkElement', function(e){
					var bookid	= $('#rentbookOverview').find('#rentBookId').val();
					var linkid	= $(this).closest('li').attr('linkid');
					rentOverview.unLinkToEntry(bookid,linkid);
				});

				$("#rentbookOverview").on('click',".linkerSearch li", function(){

					$(this).toggleClass('active');

					var searchFull = [];
					$.each($("#rentbookOverview .active"), function(k,v){
						searchFull.push(":not(.link_" +$(v).attr('search')+")");
					});

					$("#rentbookOverview .linkerContent li").show();
					if (searchFull.length > 0){
						$("#rentbookOverview .linkerContent li"+searchFull.join('')).hide();
					}


				});
			
				rentOverview.initEntryOverviewLinker();
				MyFacture.customForm();
				
				
			}
		};

		MyWindow.load("rent_book", {action:"bookOverview", id: id}, options, true, "rentPoupWindow");
	},
	
	initEntryOverviewLinker: function(){
		
		var overview = $('#rentbookOverview');
		
		overview.find('.linkedChooseType').change(function(){
			rentOverview.initEntryOverviewLinker();
		});
		
		var linkedType = overview.find('.linkedChooseType').val();
		overview.find('.linkerContainer .token-input-list').remove();
		
		switch(linkedType){
			case "purchase":
				TokenInput.autoPurchasesListing("#linkerAutocompleteType", "purOrder|purInvoice|purDelivery", 1, true, 'withdeposit',
					function(item){
						var itemId = item.id.split('_');
						rentOverview.entryOverviewLinkElement(itemId[1], 'purchase');
					}
				);
				break;
			case "document":
                var availableDoctypes = $("#availableDoctypes").val();
				TokenInput.autoDocumentListing("#linkerAutocompleteType", availableDoctypes, 1, true, 'withdeposit', 
					function(item){
						var itemId = item.id.split('_');
						rentOverview.entryOverviewLinkElement(itemId[1], 'document');
					}
				);
				break;
			case "opportunity":
				TokenInput.autoOpportunity("#linkerAutocompleteType", function(item){
					var itemId = item.id.split('_');
					rentOverview.entryOverviewLinkElement(itemId[1], 'opportunity');
				}); 
				break;
			case "support":
				TokenInput.autoSupport('#linkerAutocompleteType', function(item){
					var itemId = item.id.split('_');
					rentOverview.entryOverviewLinkElement(itemId[1], 'ticket');
				}); 
				break;
		}
		
		
	},
			
	entryOverviewLinkElement: function(linkedid, linkedtype){
		
		var overview = $('#rentbookOverview');
		overview.find('#linkerAutocompleteType').tokenInput('clear');
		
		var bookid	= $('#rentbookOverview').find('#rentBookId').val();
		
		var datas = {action:"linkElementToEntry", bookid:bookid, linkedid:linkedid, linkedtype:linkedtype};
		MyFacture.post("rent_book", datas, function(data){
			
			$('#rentbookOverview #content_booklinks .noLinkedContent').hide();
			$('#rentbookOverview #content_booklinks .linkerContent ul').append(data.rentOneLink);
			$('#rentbookOverview #content_booklinks .linkerContent ul').animate({ scrollTop: $('#rentbookOverview #content_booklinks .linkerContent ul')[0].scrollHeight}, 500);
			
		}, "json");
	},
			
	unLinkToEntry : function(bookid,linkid){
		
		var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Délier"),
					'class' : 'btn btn-primary',
					click : function(){
						$(this).dialog("close");
						var datas = {action:"unLinkElementToEntry", bookid:bookid, linkid:linkid};
						MyFacture.post("rent_book", datas, function(data){
							$('.rentOneLink[linkid='+linkid+']').remove();
							if ($('#rentbookOverview #content_linked .rentOneLink').length === 0){
								$('#rentbookOverview #content_linked .noLinkedContent').show();
							}
						}, "json");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Délier de l'entrée ?"), options);
		
	}
	
};

window.rentBook = {
	
	editForm: function(id, startTimestamp, endTimestamp, itemid, declid, items, rwhid, thirdid){
		
		var title = (id === undefined || id == "") ? Loc.g('Nouvelle location') : Loc.g('Modification de la location')
		
		var options = {
			title	: title,
			width: 1200,
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
                {
                    text : Loc.g("Enregistrer"),  
					'class' : 'btn btn-primary',
					click : function(){
						$("#bookForm").submit();
					}
				}
            ],
			callback	: function(){rentBook.prepareBookForm();}
		};

		MyWindow.load("rent_book", {action:"bookForm", id: id, startTimestamp:startTimestamp, endTimestamp:endTimestamp, itemid:itemid, declid:declid, items:items, rwhid:rwhid, thirdid:thirdid}, options, true, 'rentBookCreateForm');
		
	},
		
	prepareBookForm: function(){

		var formId = "bookForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "bookForm");
			if (formIsOk){
				MyWindow.close('rentBookCreateForm');
				rentOverview.load(data.bookid);
			}

		}, dataType:"json"};
		
		var data = {action: 'recordBookForm'};
		MyForm.prepare(formId, "rent_book&"+$.param(data), options, true);
		MyFacture.initEvent();
		Qtip.init();
		
		$("#bookForm").on('change', "input[name='rentBookForm_selectedPricing']" , function(){
			
			var taxesFree = $(this).attr('taxesfree');
			var taxesInc = $(this).attr('taxesinc');
			
			$('#rentBookForm_totalAmountTaxesFree').val(taxesFree);
			$('#rentBookForm_totalAmountTaxesInc').val(taxesInc);
			
			MyFacture.customForm();
			
		});
		
		$("#bookForm").on('change', ".rentSettingsSelect", function(){
			var selected = $(this).find(':selected').val();
			
			var id = $(this).closest('tr').find('.rentSettingsPriceSelect:visible').attr('id');
			var name = $(this).closest('tr').find('.rentSettingsPriceSelect:visible').attr('name');
			$(this).closest('tr').find('.rentSettingsPriceSelect').hide().removeAttr('id').removeAttr('name');
			
			$(this).closest('tr').find('.rentSettingid_'+selected).attr('id',id).attr('name',name).show();
			
			var unitAmountTaxesFree = $(this).closest('tr').find('.rentSettingid_'+selected).find('option:selected').attr('unitAmountTaxesFree')
			var unitAmountTaxesInc	= $(this).closest('tr').find('.rentSettingid_'+selected).find('option:selected').attr('unitAmountTaxesInc')

			var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
			
			$(this).closest('tr').find('.unitAmountTaxesFree').val(NumberFormat.formatToDisplay(unitAmountTaxesFree, numFormat));
			$(this).closest('tr').find('.unitAmountTaxesInc').val(NumberFormat.formatToDisplay(unitAmountTaxesInc, numFormat));
			
			MyFacture.customForm();
			rentBook.updateTotalRow($(this).closest('tr'));
			
		});

		$('#bookForm').on('change', ".rentSettingsPriceSelect", function(){
			
			var unitAmountTaxesFree = $(this).find("option:selected").attr('unitamounttaxesfree');
			var unitAmountTaxesInc	= $(this).find('option:selected').attr('unitamounttaxesinc');

			var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
		
			$(this).closest('tr').find('.unitAmountTaxesFree').val(NumberFormat.formatToDisplay(unitAmountTaxesFree, numFormat));
			$(this).closest('tr').find('.unitAmountTaxesInc').val(NumberFormat.formatToDisplay(unitAmountTaxesInc, numFormat));
			
			MyFacture.customForm();
			rentBook.updateTotalRow($(this).closest('tr'));
			
		});
		
		$('#bookForm').on('change', '#rentBookForm_taxesInc', function(){
			rentBook.updateTaxModeFields();
		});
		
		$('#bookForm').on("change", ".unitAmount, .unitQt, .taxId, .taxId2", function(){
			rentBook.updateTotalRow($(this).closest('tr'));
		});
		
		$("#bookForm").on("change", ".taxId, .taxId2", function(){
			rentBook.updateTotalBook();
		});
		
		if ($("#bookForm").find('#rentBookForm_id').val() == ""){
			rentBook.setFirstItemPrices();
		}
		
	},
			
	updateTaxModeFields: function(){

		var taxesInc = $("#rentBookForm_taxesInc").val();
		
		if (taxesInc == "Y"){
			$('#bookForm').find('.taxesFree').hide();
			$('#bookForm').find('.taxesInc').show();
		} else {
			$('#bookForm').find('.taxesInc').hide();
			$('#bookForm').find('.taxesFree').show();
		}
		
		MyFacture.customForm();
		
	},
	
	updateTotalRows: function(){
		$.each($('#bookForm .bookItemListRow').not('.deleted'), function(){
			rentBook.updateTotalRow($(this));
		});
		
		if ($('#bookForm .bookItemListRow').not('.deleted').length == 0){
			rentBook.updateTotalBook();
		}
	},
	
	updateTotalRow: function(row){

		// remove error
		row.find('.ui-state-error').trigger('focus');
		$('.rentBookSum').find('.ui-state-error').trigger('focus');

		var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
		var taxesInc	= $("#rentBookForm_taxesInc").val();
		
		// row QT
		var rowQt	= NumberFormat.formatToFloat(''+row.find('.unitQt').val(), numFormat);
		rowQt = new Big(rowQt);
		
		if ($("#rentBookForm_taxesInc").val() == "Y"){
			
			var unitAmount		= NumberFormat.formatToFloat(''+row.find('.unitAmountTaxesInc').val(), numFormat);
			unitAmount			= new Big(unitAmount);
			
			var totalAmount		= rowQt.times(unitAmount);
			row.find('.totalAmountTaxesInc').val(NumberFormat.formatToDisplay(totalAmount.toString(), numFormat));
			
			// set the hidden unit amount
			var taxAmount		= new Big(0);
			
			var taxrate			= Big(NumberFormat.formatToFloat(''+row.find('.taxId option:selected').attr('rate'), numFormat));
			var taxMultiplier	= new Big(1);
			taxMultiplier		= taxMultiplier.plus(Big(taxrate).div(100));	
			
			var unitAmountHT	= unitAmount.div(taxMultiplier);
			var totalAmountHT	= unitAmountHT.times(rowQt);
			
			row.find('.unitAmountTaxesFree').val(NumberFormat.formatToDisplay(unitAmountHT.toString(), numFormat));
			row.find('.totalAmountTaxesFree').val(NumberFormat.formatToDisplay(totalAmountHT.toString(), numFormat));
			
		} else {
			
			var unitAmount		= NumberFormat.formatToFloat(''+row.find('.unitAmountTaxesFree').val(), numFormat);
			unitAmount			= new Big(unitAmount);
			
			
			var totalAmount		= rowQt.times(unitAmount);
			row.find('.totalAmountTaxesFree').val(NumberFormat.formatToDisplay(totalAmount.toString(), numFormat));
			
			// set the hidden unit amount
			var taxAmount		= new Big(0);
			
			var taxrate			= Big(NumberFormat.formatToFloat(''+row.find('.taxId option:selected').attr('rate'), numFormat));
			taxAmount			= unitAmount.times(taxrate.div(100));
			
			if ($('#rentBookForm_useDoubleVat').val() == "Y"){
				
				var taxrate2	= Big(NumberFormat.formatToFloat(''+row.find('.taxId2 option:selected').attr('rate'), numFormat));
				taxAmount		= taxAmount.plus(unitAmount.times(taxrate2.div(100)));
			}
			
			var unitAmountTTC	= unitAmount.plus(taxAmount);
			var totalAmpuntTTC	= unitAmountTTC.times(rowQt);
			
			row.find('.unitAmountTaxesInc').val(NumberFormat.formatToDisplay(unitAmountTTC.toString(), numFormat));
			row.find('.totalAmountTaxesInc').val(NumberFormat.formatToDisplay(totalAmpuntTTC.toString(), numFormat));
			
		}
		
		
		rentBook.updateTotalBook();
		
	},
			
	updateTotalBook: function(){
		
		var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
		var taxesInc	= $("#rentBookForm_taxesInc").val() === "Y";
		
		var totalHT		= Big(0);
		var totalTaxes	= Big(0);
		var totalTTC	= Big(0);
		var taxes		= [];

		$.each($('#bookForm .bookItemListRow').not('.deleted'), function(){
			
			var taxid		= $(this).find('.taxId option:selected').val();
			var taxlabel	= $(this).find('.taxId option:selected').html();
			var taxrate		= Big(NumberFormat.formatToFloat($(this).find('.taxId option:selected').attr('rate'), numFormat));

			var amountHT = Big(NumberFormat.formatToFloat($(this).find('.unitAmountTaxesFree').val(), numFormat));
			var qt		 = Big(NumberFormat.formatToFloat($(this).find('.unitQt').val(), numFormat));

			var taxMultiplier	= new Big(1);
			taxMultiplier		= taxMultiplier.plus(Big(taxrate).div(100));

			amountHT = amountHT.times(qt);
			
			if (taxesInc){
				var amountTTC = Big(NumberFormat.formatToFloat($(this).find('.unitAmountTaxesInc').val(), numFormat));
				amountTTC	= amountTTC.times(qt);
				amountHT	= amountTTC.div(taxMultiplier);
				totalTTC	= totalTTC.plus(amountTTC);
			}

			if(taxes[taxid] === undefined){
				
				taxes[taxid] = {
					id				: taxid, 
					label			: taxlabel,
					rate			: Big(taxrate), 
					baseAmount		: new Big(0),
					amount			: new Big(0)
				};
				
			}
			
			taxes[taxid].baseAmount = taxes[taxid].baseAmount.plus(amountHT);
			
			if ($('#rentBookForm_useDoubleVat').val() == 'Y' && !taxesInc){
			
				var taxid2		= $(this).find('.taxId2 option:selected').val();
				var taxlabel2	= $(this).find('.taxId2 option:selected').html();
				var taxrate2	= Big(NumberFormat.formatToFloat($(this).find('.taxId2 option:selected').attr('rate'), numFormat));

				if(taxes[taxid2] === undefined){

					taxes[taxid2] = {
						id				: taxid2, 
						label			: taxlabel2,
						rate			: Big(taxrate2), 
						baseAmount		: new Big(0),
						amount			: new Big(0)
					};

				}
				
				var amountHT2 = Big(NumberFormat.formatToFloat($(this).find('.unitAmountTaxesFree').val(), numFormat));
				taxes[taxid2].baseAmount = taxes[taxid2].baseAmount.plus(amountHT2);

			}
			
			totalHT = totalHT.plus(amountHT);
			
		});
		
		if (!taxesInc){
			for(var i in taxes){
				if (taxes[i].baseAmount !== undefined){
					taxes[i].amount = taxes[i].baseAmount.times(taxes[i].rate).div(100);
					totalTaxes	= totalTaxes.plus(taxes[i].amount);
					totalTTC	= totalHT.plus(totalTaxes);
				}
			}
		}
		
		$('#bookForm #rentBookForm_totalAmountTaxesFree').val(NumberFormat.formatToDisplay(totalHT.toString(), numFormat));
		$('#bookForm #rentBookForm_totalAmountTaxesInc').val(NumberFormat.formatToDisplay(totalTTC.toString(), numFormat));
		
		MyFacture.customForm();

	},
			
	addItem: function(item){

		$('#rentBookForm_itemsid').tokenInput('clear');
		
		if ($('#bookForm .bookItemListRow').not('.deleted').length == 0){
			rentBook.editFormPricing(item);
			return;
		}

		var idSplitted	= item.id.split('_');
		var itemid		= idSplitted[1];
		var declid		= idSplitted[2];
		
		var timestampStart	= $('#rentBookForm_startdate').val() + " " + $('#rentBookForm_starttime').val();
		var timestampEnd	= $('#rentBookForm_enddate').val() + " " + $('#rentBookForm_endtime').val();
		var useDoubleVat	= $('#rentBookForm_useDoubleVat').val();
		var taxesInc		= $("#rentBookForm_taxesInc").val();
		
		if (timestampEnd != " " && timestampStart != " "){
				
			var params = {
				action		:"getRentItemPricing",
				itemid		: itemid,
				declid		: declid,
				timestampStart	: timestampStart,
				timestampEnd	: timestampEnd,
				useDoubleVat	: useDoubleVat,
				taxesInc		: taxesInc,
			}
			MyFacture.post("rent_book", params, function(data){

				var row = $(Text.replace(data.rentBookItemListRow, "%rowposition%", $('.bookItemListRow').length + 1));

				$("#bookForm #bookFormGoodsPricesContainer .bookItemListRow:last").after(row);

				var current = $("#bookForm #bookFormGoodsPricesContainer .bookItemListRow:last");
				rentBook.setFirstItemPrice(current);

				rentBook.updateTotalRow(current);

				MyFacture.customForm();
				Qtip.init();

			}, "json");
				
		}
		
	},
			
	setFirstItemPrices: function(){
		$.each($("#bookForm #bookFormGoodsPricesContainer .bookItemListRow"), function(){
			rentBook.setFirstItemPrice($(this));
			rentBook.updateTotalRow(($(this)));
		});
		rentBook.updateTotalRows();
	},
			
	setFirstItemPrice: function(current){

		var unitAmountTaxesFree = current.find(".rentSettingsPriceSelect:visible option:selected").attr('unitAmountTaxesFree');
		var unitAmountTaxesInc	= current.find('.rentSettingsPriceSelect:visible option:selected').attr('unitAmountTaxesInc');
		
		var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
		
		current.find('.unitAmountTaxesFree').val(NumberFormat.formatToDisplay(unitAmountTaxesFree, numFormat));
		current.find('.unitAmountTaxesInc').val(NumberFormat.formatToDisplay(unitAmountTaxesInc, numFormat));
		
	},
			
	removeItem: function(item){

		var id = item;
		$('#'+id).find('.rentBookItemstatus').val('deleted');
		$('#'+id).addClass('deleted').hide();
		rentBook.updateTotalRows();
	},
	
			
	editFormPricing: function(item){

		
		var itemids = [];
		
		if (item === undefined){
			$.each($('#bookForm .bookItemListRow').not('.deleted'), function(){
				itemids.push({
					id				: 'bookItem_'+$(this).find('.itemfullid').val(),
					rwhid			: $(this).find('.rentSelectedRwhid').val(),
					qt				: $(this).find('.unitQt').val()
				});
			});
		} else {
			itemids.push(item);
		}
		
		$('#bookForm #bookFormGoodsPricesContainer').html('');
		
		var timestampStart	= $('#rentBookForm_startdate').val() + " " + $('#rentBookForm_starttime').val();
		var timestampEnd	= $('#rentBookForm_enddate').val() + " " + $('#rentBookForm_endtime').val();
		var useDoubleVat	= $('#rentBookForm_useDoubleVat').val();
		var taxesInc		= $("#rentBookForm_taxesInc").val();
		
		if (itemids.length > 0 && timestampStart != " " && timestampEnd != " "){
			
			var params = {
				action			: "getRentItemsPricing", 
				itemids			: itemids,
				timestampStart	: timestampStart,
				timestampEnd	: timestampEnd,
				useDoubleVat	: useDoubleVat,
				taxesInc		: taxesInc,
			};

			MyFacture.post("rent_book", params, function(data){
				
				$('#bookForm #bookFormGoodsPricesContainer').html(data.rentBookItemListContainer);
				
				$.each($('.rentSettingsPriceSelect:visible'), function(){
					var unitAmountTaxesFree = $(this).find("option:selected").attr('unitAmountTaxesFree');
					var unitAmountTaxesInc	= $(this).find('option:selected').attr('unitAmountTaxesInc');
					
					var numFormat	= NumberFormat.loadFromInputs('booknumformat_');
					
					$(this).closest('tr').find('.unitAmountTaxesFree').val(NumberFormat.formatToDisplay(unitAmountTaxesFree, numFormat));
					$(this).closest('tr').find('.unitAmountTaxesInc').val(NumberFormat.formatToDisplay(unitAmountTaxesInc, numFormat));
					
					rentBook.updateTotalRow($(this).closest('tr'));
				});
				
				MyFacture.customForm();
				Qtip.init();
			}, "json");
			
		} 
		
	},
			
	chooseFormPricing: function(){

		var selected = $('#rentSettingsChooseSettings').val();
		
		var id				= $('#rentBookForm_itemid').val().split('_')[1]+"_"+$('#rentBookForm_itemid').val().split('_')[2];
		var timestampStart	= $('#rentBookForm_startdate').val() + " " + $('#rentBookForm_starttime').val();
		var timestampEnd	= $('#rentBookForm_enddate').val() + " " + $('#rentBookForm_endtime').val();
		
		var params = {
			action:"getRentItemPricing", 
			id:id,
			rentSettingsId	: selected,
			timestampStart	: timestampStart,
			timestampEnd	: timestampEnd
		};

		MyFacture.post("rent_book", params, function(data){
			
			
			var row = $(Text.replace(data.bookItemDetails, "%rowposition%", $('.bookItemListRow').length + 1));
			
			$('#bookForm #bookFormGoodsPricesContainer').html(row);
			MyFacture.customForm();
		}, "json");
		
	},
			
	deleteBook: function(id){

		var title = Loc.g('Supprimer l’entrée ?')

		var options = {
			'type' : 'warning',
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
                {
                    text : Loc.g("Supprimer"), 
					'class' : 'btn btn-primary',
					click : function(){
                    $(this).dialog("close");
                    MyFacture.post("rent_book", {action:"deleteBook", id:id}, function(data){
                        Utils.reload();
                    }, "json");
                }}
            ],
		};

		MyWindow.alert(title, options);

	},
	
	cancelBook: function(id){

		var title = Loc.g('Annuler l’entrée ?')

		var options = {
			'type' : 'warning',
			buttons	: [
				{
					text : Loc.g("Non"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g('Oui'),
					'class' : 'btn btn-primary',
					click : function(){
						$(this).dialog("close");
						MyFacture.post("rent_book", {action:"cancelBook", id:id}, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]	
		};

		MyWindow.alert(title, options);

	},
	
	converToLoc: function(id){

		var title = Loc.g('Convertir en location ?')

		var options = {
			'type' : 'warning',
			buttons	: [
				{
					text : Loc.g("Non"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						$(this).dialog("close");
						MyFacture.post("rent_book", {action:"convertToRent", id:id}, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]	
		};

		MyWindow.alert(title, options);

	},
	
	createFroGoodsList: function(rowSelection){
		
		var cleanSelection = [];
		$.each(rowSelection, function(i, v){
			
			var tmpSelection = {};
			var splittedVal = v.split('_');
			tmpSelection.itemid = splittedVal[1];
			tmpSelection.declid = splittedVal[2];
			
			cleanSelection.push(tmpSelection);
			
		});
		
		var start	= $('#availableGoodsListing_rentStartAt').val();
		var end		= $('#availableGoodsListing_rentEndAt').val();
		
		rentBook.editForm('',start,end,'','',cleanSelection);
		
	}
	
};

window.rentBookCheck = {
	
	checkDispoForm: function(itemid, declid){
		
		itemid = itemid === undefined ? 0 : itemid;
		declid = declid === undefined ? 0 : declid;
		
		var title = Loc.g('Vérifier une disponibilité');
		
		var options = {
			title	: title,
			width: 1200,
			buttons	: [
                {
                    text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
                },
                {
					text : Loc.g("Vérifier la disponibilité"),  
					'class' : 'btn btn-primary',
					click : function(){
						$("#bookCheckForm").submit();
					}
				}
			],
			callback	: function(){rentBookCheck.prepareCheckDispoForm();}
		};

		MyWindow.load("rent_book", {action:"bookChekForm", itemid:itemid, declid:declid}, options, true, 'bookCheckFormPopup');
		
	},
			
	prepareCheckDispoForm:function(){
		
		var formId = "bookCheckForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, formId);
				if (formIsOk){
					$('#'+formId).find('#rentBookCheckResultContainer').html(data.rentBookCheckResult);
					Qtip.init();
				}
			}, 
			beforeSubmit : function(){
				$('#'+formId).find('#rentBookCheckResult').remove();
			},
			dataType:"json",
		};
		
		var data = {action: 'recordBookChekForm'};
		
		MyForm.prepare(formId, "rent_book&"+$.param(data), options, true);
		MyFacture.initEvent();
		
		
		$('#bookCheckForm').find('input').change(function(){
			$("#bookCheckForm").find('.alert-success').hide();
		});
	},
			
	convertDispoToBook: function(rwhid){
		
		var itemid	= $('#bookCheckForm #book_itemid').val().split('_')[1];
		var declid			= $('#bookCheckForm #book_itemid').val().split('_')[2];
		var startTimestamp	= $('#bookCheckForm #book_startdate').val() + " " + $('#bookCheckForm #book_starttime').val();
		var endTimestamp	= $('#bookCheckForm #book_enddate').val() + " " + $('#bookCheckForm #book_endtime').val();
		
		rentBook.editForm('',startTimestamp,endTimestamp, itemid, declid, {}, rwhid);
		MyWindow.close('bookCheckFormPopup');

	}
};

window.rentItem = {
	
	rentEditOnChild: function(){
		MyWindow.alert(Loc.g("Pour gérer les paramètres de location, rendez vous sur une fiche déclinaison."), {type:'warning'});
	},
	
	enableRentOnParent: function(type, id){
	
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Aller sur le produit parent"), 
					'class' : 'btn btn-primary',
					click : function(){
						Utils.relocate("?_f=catalogueitem&id="+id+"&type="+type)
						
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous devez passer par le produit parent pour activer la location."), options);
		
	},
	
	disableRent: function(itemid){
		
		var msg =  Loc.g('Désactiver la location pour ce produit ?. Si ce produit est décliné, la location sera aussi désactivée pour les déclinaisons.');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Désactivation de la location"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Oui"), 
					'class' : 'btn btn-primary',
					click : function(){
						var datas = {action:"rentDesactivationForm", itemid:itemid};
						MyFacture.post("rent_rentitem", datas, function(data){Utils.reload();}, "json");
						
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},
	
	reenableRent: function(itemid){
		
		var msg =  Loc.g('Re activer la location pour ce produit ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Reactivation de la location"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Oui"), 
					'class' : 'btn btn-primary',
					click : function(){
						var datas = {action:"rentreactivationForm", itemid:itemid};
						MyFacture.post("rent_rentitem", datas, function(data){Utils.reload();}, "json");
						
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},
	
	enableRent: function(itemid, enableAndEditSettings){
		
		var buttons = [];
		
		buttons.push(
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}}
		);

		if (enableAndEditSettings == "Y"){
			buttons.push(
					{text : Loc.g("Activer et paramétrer les tarifs"), click : function(){
						
						var useRentStock = $('#useRentStock').val();
						var datas = {action:"enableRentForm", itemid:itemid, useRentStock:useRentStock};
					
						MyFacture.post("rent_rentitem", datas, function(data){rentItem.rentSettingsForm(itemid)}, "json");
						
					}}
			);
		}
		
		buttons.push(
				{text : Loc.g("Activer simplement"), click : function(){
						
						var useRentStock = $('#useRentStock').val();
						var datas = {action:"enableRentForm", itemid:itemid, useRentStock:useRentStock};
						
						MyFacture.post("rent_rentitem", datas, function(data){Utils.reload();}, "json");
						
				}}
		);
		
		var options = {
			resizable	: false,
			noclose		: true,
			width		: "600",
			title		: Loc.g("Activer la location"),
			buttons		: buttons
		};

//		MyWindow.alert(msg, options);
		MyWindow.load("rent_rentitem", {action:"enableRentView", itemid:itemid, enableAndEditSettings:enableAndEditSettings}, options);
		
	},
	
	deleteSeasonnalSettings: function(seasonnalid){
		
			var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Supprimer"),
					'class' : 'btn btn-primary',
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteRentItemSeasonnalSettings", seasonnalid:seasonnalid};
						MyFacture.post("rent_rentitem", datas, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Supprimer les paramètres saisonniers ?"), options);
		
	},
	
	rentSettingsView: function(itemid, declid, isSeasonnal, seasonnalid){
		
		var declid		= declid === undefined ? 0 : declid;
		var isSeasonnal = isSeasonnal === undefined ? 'N' : isSeasonnal;
		var seasonnalid = seasonnalid === undefined ? 0 : seasonnalid;
		
		var title = Loc.g('Tarifs de la location');
		
		if (isSeasonnal == 'Y'){
			title = Loc.g('Tarifs saisonniers de la location')
		}
		
		var options = {
			title	: title,
			width: 800,
			buttons	: [
                {
                    text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
                },
                {
					text : Loc.g("Modifier"), 
					'class' : 'btn btn-primary',
					click : function(){rentItem.rentSettingsForm(itemid, declid, isSeasonnal, seasonnalid)}
				}
				],
			callback	: function(){}
		};

		MyWindow.load("rent_rentitem", {action:"rentSettingsView", itemid:itemid, declid:declid, isSeasonnal:isSeasonnal, seasonnalid:seasonnalid }, options);
		
	},

	rentItemWarehouseForm: function(itemid, declid){

		var declid	= declid === undefined ? 0 : declid;
		var title	= Loc.g('Gérer les quantités');
		
		var options = {
			title	: title,
			width: 900,
			buttons	: [
                {
                    text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
                },
                {
					text : Loc.g("Enregistrer"),  
					'class' : 'btn btn-primary',
					click : function(){
						$("#rentItemWarehouseForm").submit();
					}
				}
				],
			callback	: function(){rentItem.prepareRentItemWarehouseForm();}
		};

		MyWindow.load("rent_rentitem", {action:"rentItemWarehouseForm", itemid:itemid, declid:declid}, options);

	},
			
	prepareRentItemWarehouseForm: function(){

		var formId = "rentItemWarehouseForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "rentItemWarehouseForm");
			if (formIsOk){
				Utils.reload();
			}
		}, dataType:"json"};
		var data = {action: 'recordRentItemWarehouseFormm'};
		MyForm.prepare(formId, "rent_rentitem&"+$.param(data), options, true);
		MyFacture.initEvent();
		Qtip.init();

	},
	
	rentSettingsForm: function(itemid, declid, isSeasonnal, seasonnalid){
		
		var declid		= declid === undefined ? 0 : declid;
		var isSeasonnal = isSeasonnal === undefined ? 'N' : isSeasonnal;
		var seasonnalid = seasonnalid === undefined ? 0 : seasonnalid;

		var title = Loc.g('Tarifs de la location');
		
		if (isSeasonnal == 'Y'){
			title = Loc.g('Tarifs saisonniers de la location')
		}

		var saveBtn = {
			text : Loc.g("Enregistrer"),
			'class': 'btn btn-primary',
			click : function(){
				$("#rentItemSettingsForm").submit();
			}
		};
		
		var forceRentItemWarehouseFormBtn = {
			text : Loc.g("Enregistrer et gérer les quantités en stock"), 
			'class' : 'btn btn-primary',
			click : function(){
				$("#rentItemSettingsForm").submit();
			}
		};
		
		var closeBtn = {
			text : Loc.g("Annuler"), 
			'class' : 'btn btn-default',
			click : function(){
				$(this).dialog("close");
			}
		};

		var options = {
			title	: title,
			width: 800,
			callback	: function(){
		
				var buttons = [];
				buttons.push(closeBtn);
				if ($("#rentItemSettingsForm #forceRentItemWarehouseForm").val() == 'Y'){
					buttons.push(forceRentItemWarehouseFormBtn);
				} else {
					 buttons.push(saveBtn);
				} 
				
				MyWindow.addOption('buttons',buttons);
		
				rentItem.prepareRentSettingsForm();
				
			}
		};

		MyWindow.load("rent_rentitem", {action:"rentItemSettingsForm", itemid:itemid, declid:declid, isSeasonnal:isSeasonnal, seasonnalid:seasonnalid }, options);
		
	},
	
	prepareRentSettingsForm: function(){
		
		var formId = "rentItemSettingsForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "rentItemSettingsForm");
			if (formIsOk){
				
				if ($("#rentItemSettingsForm #forceRentItemWarehouseForm").val() == 'Y'){
					rentItem.rentItemWarehouseForm(data.itemid, data.declid);
				} else {
					Utils.reload();
				}
			}

		}, dataType:"json"};
		
		var data = {action: 'recordRentItemSettingsForm'};
		MyForm.prepare(formId, "rent_rentitem&"+$.param(data), options, true);
		MyFacture.initEvent();
		
	},
			
	editFormPrepareRentSettings: function(view){
		
		if (view.checked){
			$('#rentItemSettingsForm .rentSettings_'+view.value).show();
			MyFacture.customForm("#rentItemSettingsForm");
		} else {
			$('#rentItemSettingsForm .rentSettings_'+view.value).hide();
		}
		
	},
	
	removeOnePricingX: function(me){
		me.closest('.onePricingX').remove();
	},
			
	addOnePricingX: function(view){

		var template = $('.onePricingXTemplate').clone();
		var nbPrice = $('.onePricingX').length + 1;
		template.attr('class', 'onePricingX');
		
		template.find("[for='item_rentSettings_x_TEMPLATE_ident']").attr('for','item_rentSettings_x_'+nbPrice+'_ident');
		template.find("[id='item_rentSettings_x_TEMPLATE_ident']").attr('name','item_rentSettings[x]['+nbPrice+'][ident]').attr('id','item_rentSettings_x_'+nbPrice+'_ident');
		
		template.find("[for='item_rentSettings_x_TEMPLATE_nb']").attr('for','item_rentSettings_x_'+nbPrice+'_nb');
		template.find("[id='item_rentSettings_x_TEMPLATE_nb']").attr('name','item_rentSettings[x]['+nbPrice+'][nb]').attr('id','item_rentSettings_x_'+nbPrice+'_nb');
		
		template.find("[for='item_rentSettings_x_TEMPLATE_type']").attr('for','item_rentSettings_x_'+nbPrice+'_type');
		template.find("[id='item_rentSettings_x_TEMPLATE_type']").attr('name','item_rentSettings[x]['+nbPrice+'][type]').attr('id','item_rentSettings_x_'+nbPrice+'_type');
		
		template.find("[for='item_rentSettings_x_TEMPLATE_price']").attr('for','item_rentSettings_x_'+nbPrice+'_price');
		template.find("[id='item_rentSettings_x_TEMPLATE_price']").attr('name','item_rentSettings[x]['+nbPrice+'][price]').attr('id','item_rentSettings_x_'+nbPrice+'_price');;
		
		$('.onePricingXContainer').append(template);
		MyFacture.customForm();
		
	}
	
};

window.rentQtHistory = {
	
	more : function(itemid, declid){
		
		var timestamp = $('#itemHasRentQtHistoryContainer .itemHasRentQtHistoryList li:last').attr('timestamp');
		
		MyFacture.post("rent_rentitem", {action:"moreRentItemHistoryQt", itemid:itemid, declid:declid, timestamp:timestamp}, function(data){
			
			if (data.itemHasRentQtHistory.length > 0){
				$('#itemHasRentQtHistoryContainer .itemHasRentQtHistoryList').append(data.rentQtHistoryRows);
			} else {
				$('#itemHasRentQtHistoryContainer .rentQtHistoryMore').remove();
			}
			
		}, "json");
	}
};
